import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  onCloseProposta: () => void;
}

const VoltarFluxoModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        onCloseProposta={() => props?.onCloseProposta()}
      />
    </Styles.Container>
  );
};

export default VoltarFluxoModal;
